module.exports = __webpack_public_path__ + "img/empty.1248e3ea.png";